module.exports = __webpack_public_path__ + "img/vertical_6_7_8004.d644859b.png";